import React from 'react';
import GeneratorTool from '../components/GeneratorTool'; // Import the tool

// --- ★ MODIFICATION: Accept 'onJobStarted' prop ---
const SocialPage = ({ session, onJobStarted }) => {
    return (
        // Render the GeneratorTool, passing down the session
        // and setting the specific toolType for social media
        <GeneratorTool 
          session={session} 
          toolType="social" 
          onJobStarted={onJobStarted} // <-- Pass it down
        />
    );
};

export default SocialPage;